import * as React from 'react';
import { DomComponentProps, DomElement } from '.';

interface TabsState {
    selectedTab?: HTMLElement;
}

export class Tabs extends React.Component<DomComponentProps, TabsState> {
    constructor(props: DomComponentProps) {
        super(props);
        this.state = { selectedTab: this.props.domChildSelected };
    }

    render() {
        const { selectedTab } = this.state;
        const { domChildren } = this.props;
        return (
            <div className="contact-choice-container contact-tabs">
                <ul className="contact-choice">
                    {domChildren.map((i, idx) => {
                        const link = i.dataset.link ? i.dataset.link : '#';
                        return (
                            <li key={idx}>
                                <a
                                    key={idx}
                                    href={link}
                                    className={`contact-choice__item tabs__link${selectedTab ? (i === selectedTab ? ' active' : ' inactive') : ''}`}
                                    aria-expanded={
                                        selectedTab === i ? 'true' : 'false'
                                    }
                                    onClick={
                                        link == '#'
                                            ? (e) => {
                                                  this.setState({
                                                      selectedTab: i,
                                                  });
                                                  e.preventDefault();
                                              }
                                            : undefined
                                    }
                                >
                                    <i
                                        className={`${i.dataset.icon || 'icon-write'} visual-icon`}
                                    ></i>
                                    <div className="title_tabs">
                                        {i.dataset.label}
                                    </div>
                                    <i className="icon-angleBottom selector"></i>
                                    <i className="icon-cross selector"></i>
                                </a>
                            </li>
                        );
                    })}
                </ul>
                <div className="tabs__content--container">
                    {domChildren.map((i, idx) => (
                        <div
                            key={idx}
                            className={`tabs__content${i === selectedTab ? ' active' : ''}`}
                        >
                            <div className="contact-panel">
                                <div className="align-right d-none d-lg-block">
                                    <button
                                        className="btn-no-look tabs__close"
                                        onClick={() =>
                                            this.setState({
                                                selectedTab: undefined,
                                            })
                                        }
                                    >
                                        <i className="icon-cross"></i>
                                    </button>
                                </div>
                                <DomElement element={i} />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    }
}
